//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';

//local imports
import { RoomContentModel } from '@app/catalog';
import { PresenterType } from '@app/shared';



@PresenterType({
  model: RoomContentModel,
  key: 'tileTop'
})
@Component({
  selector: 'room-content-carousel-item',
  templateUrl: './room-content-carousel-item.component.html',
  styleUrl: './room-content-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RoomContentCarouselItemComponent {
  public data: WritableSignal<RoomContentModel> = signal<RoomContentModel>(undefined);
}
